<nz-alert nzType="info"
          class="mx-4 mt-2 mb-2 d-none d-lg-block"
          [nzMessage]="infoMessage"
          nzShowIcon></nz-alert>

<ng-template #infoMessage>
  Мы очень рады вашему визиту! Нам не терпелось вас пригласить, но сервис еще на ранней стадии, если будут ошибки или
  проблемы любого рода, пожалуйста обращайтесь
  по ссылке <a target="_blank" href="https://t.me/{{senderService.helpChatUserName}}">техподдержка</a> или в <a
  (click)="senderService.openHelpChat()">чате</a>, мы оперативно исправим проблему или объясним как пользоваться.
  Приятного пользования!
</ng-template>
<div class="control-section">

  <div *ngIf="(isLoading$ | async); else kanbanRef" class="loader-line"></div>
  <ng-template #kanbanRef>
    <app-error-show
      (onReload)="reload('button')"
      [Service]="Service"
      [error]="isLoadError$.value"
      *ngIf="(isLoadError$ | async) && (kanbanData$ | async)?.length === 0; else elseBlock"
      class="h-100"
    ></app-error-show>
    <div class="content-wrapper">

      <ng-template #elseBlock>
        <ejs-kanban *ngIf="(kanbanData$ | async).length > 0; else addScanTaskRef" (dragStop)="onDragLead($event)"
                    [enableVirtualization]="false" #kanbanObj
                    cssClass='kanban-card-template'
                    keyField='Category' [dataSource]='(kanbanData$ | async)'
                    [cardSettings]='cardSettings' [sortSettings]='sortSettings'>
          <e-columns>
            <e-column *ngFor="let item of columns" [headerText]="item.headerText" [allowToggle]="true"
                      [isExpanded]="item.isExpanded" [showAddButton]="false"
                      [keyField]="item.keyField">
              <ng-template #template let-data>
                <div class="e-header-title d-flex align-items-center">
                  <div class="e-header-text">
                    <span class="icon-title"><i-feather [name]="item.icon"></i-feather></span>
                    {{data.headerText}}
                  </div>
                  <div class="e-item-count">- {{data.count}}</div>
                  <app-leads-scan-tasks-kanban-filter *ngIf="data.headerText == 'Новые'" (onFilter$)="loadLeads()"></app-leads-scan-tasks-kanban-filter>
                  <button (click)="clearColumn(data.keyField)" class="clear-button" nz-button nzType="default"
                          nzShape="circle">
                    <i-feather name="trash-2" class="text-danger"></i-feather>
                  </button>
                </div>
              </ng-template>
            </e-column>
          </e-columns>
          <ng-template #cardSettingsTemplate let-data>

            <div [attr.data-id]="data.message_time" (click)="openTooltip(data)" nzTooltipPlacement="bottom" #leadTooltip
                 nz-tooltip
                 [nzTooltipTitle]="HtmlContent" nzTooltipTrigger="click"
                 nzTooltipOverlayClassName="lead-tooltip-overlay"
                 [class.active]="(toolTopLead$ | async)?.id === data.id"
                 class="element-kanban element-canban-status-unviewed">
              <div class="btn-more-wrap">
                <div (click)="contextMenuOpen($event, data)" class="btn-more pointer">
                  <i-feather name="chevron-down" class="icon-lg"></i-feather>
                </div>
              </div>
              <div class="status-and-similarity">
                <div>
                  <div class="status" [class.text-muted]="data.viewed">
                    <div class="before" [style.background-color]="data?.scan_task_color"></div>
                    {{data.viewed ? 'Просмотрено' : 'Непросмотрено'}}
                  </div>
                  <div *ngIf="data.message_time || data.message?.message?.time as time" class="date">
                    <div class="icon-date">
                      <i-feather class="text-muted" name="clock"></i-feather>
                    </div>
                    <div class="value-date text-muted">{{ time | date: 'd.MMM' }} {{ time | date: 'shortTime' }}</div>
                  </div>
                </div>
                <div class="simmilatiry">
                  <div class="value {{data.scope_class}}">{{data.Scope * 100 | number : '1.2-2'}}%</div>
                  <div class="text">сходство с ТЗ</div>
                </div>
              </div>
              <div *ngIf="data.message?.message?.text as text" class="kanban-footer">
                <div [innerHTML]="text" class="tags"></div>
                <!--<div *ngIf="text?.length > 100; else textRef" nz-tooltip [nzTooltipTitle]="textRef" [innerHTML]="text" class="tags"></div>
                <ng-template #textRef>
                  <div [innerHTML]="text" class="tags"></div>
                </ng-template>-->
              </div>
              <div class="control-and-like">
                <!--<div class="control">
                  <div class="btn">
                    <div class="text">Задание:</div><div class="value">Название 1</div>
                  </div>
                </div>-->
                <!--<div class="like">
                  <img src="/img/icons/like.svg" class="icon-like" alt="">
                  <img src="/img/icons/like-active.svg" class="icon-like-active" alt="">
                </div>-->
              </div>
            </div>
            <div *ngIf="false" (click)="openTooltip(data)" nzTooltipPlacement="bottom" #leadTooltip nz-tooltip
                 [nzTooltipTitle]="HtmlContent" nzTooltipTrigger="click" nzTooltipOverlayClassName="big"
                 [class.active]="(toolTopLead$ | async)?.id === data.id"
                 class="card">
              <div class="btn-more-wrap">
                <div (click)="contextMenuOpen($event, data)" class="btn-more pointer">
                  <i-feather name="chevron-down" class="icon-lg"></i-feather>
                </div>
              </div>
              <div class="card-progress" [style.background-color]="data.color" placement="right"
                   tooltip="Схожесть {{data.Scope * 100 | number}}% на: «{{data.Ad}}»">
                <div class="card-progress-line" [style.height.%]="100 - data.Scope * 100"></div>
              </div>
              <div class='card-title px-3 text-truncate'
                   [innerHTML]="data.message?.message?.text || data.Ad"></div>

              <div class="d-flex align-items-center justify-content-between px-3">
                <div *ngIf="data.message?.message?.time as time" class="d-flex align-items-center">
                  <i-feather name="clock"></i-feather>
                  <div class='e-mins'>{{ time | date: 'd.MMM' }} {{ time | date: 'shortTime' }}</div>
                </div>
                <a class="e-link pointer d-md-none" (click)="leadsService.openMessage(data, Service)">
                  <i-feather name="send"></i-feather>&nbsp;Ответить
                </a>
              </div>
            </div>
          </ng-template>
        </ejs-kanban>
      </ng-template>
      <ng-template #addScanTaskRef>
        <div class="text-center d-flex h-100 pt-5 align-items-center justify-content-center px-4">
          <div [style.max-width.px]="600">
            <ng-template [ngIf]="(leadsService.leadTasks$ | async).length === 0" [ngIfElse]="waitScanRef">
              <i-feather name="empty" class="big-icon normal"></i-feather>
              <h3 class="text-super-muted mb-4">пока что тут пусто...</h3>
              <div class="mb-4 lead-text-info">Добавьте свое первое задание для сканирования чатов.<br>
                Искусственный интеллект найдет подходящие предложения, с которыми вы сможете работать в встроенной CRM.
              </div>
              <button (click)="addScanTask()" class="" nz-button nzType="primary" nzSize="large" nzShape="round">
                Начать
                <i-feather name="plus-circle" class="ml-2"></i-feather>
              </button>
            </ng-template>
            <ng-template #waitScanRef>
              <div class="mb-4">
                <i-feather name="target" class="big-icon normal"></i-feather>
                <h3 class="text-super-muted mb-4">ищем варианты...</h3>
                <div class="lead-text-info">
                  Сканирование запущено. Как только искусственный интеллект найдет подходящие варианты, они появятся
                  здесь. <br>
                  Поиск может занять чуть больше времени, в зависимости от ваших настроек и активности в чатах.<br>
                  Если за несколько часов не повилось лидов, добавьте больше чатов и примеров сообщений.

                </div>

              </div>
            </ng-template>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-template>
</div>

<context-menu [contextMenu]="contextMenuLead">
  <ng-template [visible]="true" (execute)="leadsService.openMessage($event.item, Service)" contextMenuItem let-item>
    Ответить&nbsp;<i-feather class="ml-auto float-right" name="external-link"></i-feather>
  </ng-template>
  <ng-template [visible]="leadsService.hasChat" (execute)="leadsService.openMessageInTelegram($event.item)"
               contextMenuItem let-item>
    Ссылка на сообщение&nbsp;<i-feather class="ml-auto float-right" name="external-link"></i-feather>
  </ng-template>
  <ng-template [visible]="leadsService.hasPrivate" (execute)="leadsService.openUserChatInTelegram($event.item)"
               contextMenuItem let-item>
    Ссылка на профиль&nbsp;<i-feather class="ml-auto float-right" name="external-link"></i-feather>
  </ng-template>
  <ng-template [visible]="true" (execute)="ignoreLead($event.item)" contextMenuItem let-item>
    Не подходит&nbsp;<i-feather class="ml-auto float-right normal size-16" name="dislike"></i-feather>
  </ng-template>
  <ng-template [visible]="true" (execute)="deleteLead($event.item)" contextMenuItem let-item>
    Удалить&nbsp;<i-feather class="ml-auto float-right text-danger" name="trash-2"></i-feather>
  </ng-template>


</context-menu>


<ng-template #HtmlContent>
  <div *ngIf="(toolTopLead$ | async) as data" class="tooltip-lead">
    <div class="lead-tooltip-header">
      <div class="row justify-content-between">
        <div class="col">
          <h5>Совпадение <b class="text-{{getColor(data.Scope)}}">{{data.Scope * 100 | number}}%</b> с Вашим
            примером:</h5>
          <div class="pb-2">
            <span class="color-line" [style.background-color]="data.color"></span>{{data.Ad}}
          </div>
        </div>
        <div class="col-auto d-flex">
          <button
            *ngIf="leadsService.hasPrivate(data)"
            (click)="leadsService.openUserChatInTelegram(data)"
            tooltip="Открыть&nbsp;профиль в телеграм"
            placement="left"
            class="btn btn-link expand-lead-chat px-3">
            <i-feather name="usero" class="icon-lg text-dark"></i-feather>
          </button>
          <button
            *ngIf="leadsService.hasPrivate(data)"
            (click)="openUserChat(data)"
            tooltip="Открыть в мессенджере"
            placement="left"
            class="btn btn-link expand-lead-chat px-3">
            <i-feather name="expand" class="icon-lg text-dark"></i-feather>
          </button>
          <button
            (click)="closeLead()"
            class="btn btn-link close-lead-chat px-3">
            <i-feather name="closeo" class="icon-lg text-dark"></i-feather>
          </button>
        </div>
      </div>
    </div>
    <div class="lead-tooltip-body">
      <app-chat-show-inner
        *ngIf="gerLeadUserId(data); else leadMessageRef"
        class="w-100"
        [Service]="Service"
        [demoMessage]="getLeadMessage(data)"
      >
      </app-chat-show-inner>
      <ng-template #leadMessageRef>
        <div class="tooltip-wrap-text chat-bg viewport chat-content-bg messages-container mb-4"
             #messagesContainer
             *ngIf="data?.message?.message as message">

          <app-message
            [out]="true"
            [isAvatar]="true"
            [attr.id]="'message-' + message.id"
            [attr.data-id]="message.id"
            class="message message-base message-lead px-3 px-lg-6"
            [class.message-right]="message.out"
            [class.read]="message.read"
            [message]="message"
            [Service]="Service"
            [index]="0"
            [messagesContainer]="messagesContainer">
          </app-message>
        </div>
      </ng-template>

      <!--<div class="row">
        <div class="col">
          <b>Совпадение:</b>
        </div>
        <div class="col">

        </div>
      </div>-->
    </div>
    <div class="lead-tooltip-footer btn-group-icons d-flex justify-content-between w-100 position-relative">
      <!--<button (click)="closeTooltips()">Закрыть</button>
      <span></span>-->
      <ng-template [ngIf]="leadsService.hasChat(data)">
        <button (click)="openMessage(data)">
          <i-feather name="chat" class="mr-5"></i-feather>
          Ответить в чате
        </button>
        <span></span>
      </ng-template>
      <button (click)="ignoreLead(data)">
        <i-feather name="dislike" class="normal mr-5"></i-feather>
        Не подходит
      </button>
      <span></span>
      <button (click)="deleteLead(data)">
        <i-feather name="trash" class="mr-5"></i-feather>
        Удалить
      </button>
    </div>
  </div>
</ng-template>
